// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__vpkYq","modal":"modal_modal__Mlb3Z","slide-down":"modal_slide-down__IkXXH"};